/**
 * Writes a text string to the system clipboard.
 *
 * Uses the async Clipboard API when available (requires a secure context —
 * HTTPS or localhost). Falls back to the legacy `execCommand('copy')` for
 * insecure contexts (e.g. an app served over plain HTTP), where
 * `navigator.clipboard` is unavailable.
 *
 * @async
 * @param {string} text text to be written to the clipboard
 * @throws {Error} unable to copy text to clipboard
 */
const legacyCopy = text => {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  // Mantém fora da tela e sem afetar o scroll/foco visível
  textArea.style.position = 'fixed';
  textArea.style.top = '-9999px';
  textArea.style.left = '-9999px';
  textArea.setAttribute('readonly', '');
  document.body.appendChild(textArea);
  textArea.select();
  textArea.setSelectionRange(0, text.length);

  let successful = false;
  try {
    successful = document.execCommand('copy');
  } finally {
    document.body.removeChild(textArea);
  }

  if (!successful) {
    throw new Error('Unable to copy text to clipboard: execCommand failed');
  }
};

export const copyTextToClipboard = async text => {
  // Caminho preferencial: Clipboard API (só em contexto seguro — HTTPS/localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch (error) {
      // Cai para o fallback abaixo caso a API falhe (ex.: permissão negada)
    }
  }

  // Fallback para contextos inseguros (HTTP)
  legacyCopy(text);
};
